<template>
  <div>
    <div class="inner-page-loader">
      <v-btn x-large loading text depressed></v-btn>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {},
  computed: {},
};
</script>
